// Values valid for dev/prod/local

import {
  COUNTRY,
  COUNTRY_GEOSERVER,
  HECTARE,
  REGION,
  REGION_GEOSERVER,
  SUBDIVISION,
  SUBDIVISION_GEOSERVER,
} from '@core/constants/scale.data'

export const environmentOM4ABase = {
  production: false,
  debug: true,
  appName: 'openMod4Africa',
  continent: 'Africa',
  apiUrl: '', // will be completed during ng build or ng serve based on configuration
  geoserverUrl: '', // will be completed during ng build or ng serve based on configuration
  wikiUrl: 'https://openmod4africa.github.io/wiki/',
  feedback: '',
  feedbackUrl: '',
  enableLogin: true,
  logoUrl: '/assets/projects/om4a/openmod4africa_logo.png',
  partnersLogosUrl: '',
  favicon: '/assets/projects/om4a/OM4A-favicon.ico',
  websiteUrl: 'https://openmod4africa.eu/',
  dataSetURl: 'https://gitlab.com/openmod4africa',
  repositoryUrl: 'https://vlbeltuleapce.hevs.ch/plugins/git/git-eranet',
  keycloakClientId: 'frontend',
  contactEmail: 'openmod4africa@hevs.ch',
  introText:
    'OpenMod4Africa aims to develop an open Toolbox populated with state-of-the-art models for analysing long-term pathways to sustainable, secure and competitive energy systems in Africa. The Toolbox will build on EU projects like Open ENTRANCE, Plan4RES and FocusAfrica, and will adapt and further develop open models in accordance with the African context and needs. The models are scalable, and can be applied to cities, industries and countries. Furthermore, a main objective for OpenMod4Africa is capacity building among energy models in academia. Four African universities will be actively involved in adapting models and conducting two regional case studies. The additional capacity and the open Toolbox will enable the universities to train new generations of energy modelling experts for the energy industries in Africa. Three decision-makers will also be engaged, together with a network of energy industries and universities in 25 African countries. These players will be invited to use the Toolbox, and to be involved in training activities. They will also be invited to a permanent network of expertise, which will be developed for further capacity building and collaboration beyond the project. Two case studies will develop energy pathways for rural areas, cities, countries and large regions of countries in Western and Eastern Africa. The replication strategies will pave the way for further analyses beyond the project. Finally, OpenMod4Africa aims to collaborate with other ongoing initiatives to maximize the impacts of the project and create synergies. Th consortium consists of 17 partners, eight of which are African. Important long-term impacts from the three-year project include enabling academia and decision-makers in Africa to conduct their own analyses for the optimal development of their energy system, supplying energy to a much larger share of the population, and establishing a system based upon the abundant share of renewables on the continent.',
  feedbackText:
    'We are happy to receive feedback on the tool. Please use the feedback-button in the toolbox to let us know your opinions and suggestions for the tool. OpenMod4Africa also invites other developers to contribute with additional calculation modules or datasets that can be integrated in the toolbox. Please also get in contact with us at dev.easilab@hevs.ch if you want to take part in the future development of the platform.',
  fundingText: '',
  fundingImg: '/assets/projects/om4a/OM4A-funding.png',
  centerMap: [2, 20],
  zoom: 4,
  scaleInitial: 'Country',
  countryCodes:
    'dz,ao,bj,bw,bf,bi,cm,cv,cf,td,km,cg,cd,dj,eg,gq,er,sz,et,ga,gm,gh,gn,gw,ci,ke,ls,lr,ly,mg,mw,ml,mr,mu,ma,mz,na,ne,ng,rw,st,sn,sc,sl,so,za,ss,sd,tz,tg,tn,ug,zm,zw',
  prefixWorkspaceName: 'openmod:',
  scaleRequest: [
    {
      id: 7,
      displayName: REGION,
      apiName: 'regions',
      geoServer: REGION_GEOSERVER, // regions
      payloadScale: 'om4a',
      option: {
        layers: 'openmod:regions',
        format: 'image/png8',
        transparent: true,
        version: '1.3.0',
        cql_filter: '',
        srs: 'EPSG:4326',
        zIndex: 5,
      },
    },
    {
      id: 6,
      displayName: COUNTRY,
      apiName: 'boundaries0',
      geoServer: COUNTRY_GEOSERVER, // boundaries0
      payloadScale: 'om4a',
      option: {
        layers: 'openmod:boundaries0',
        format: 'image/png8',
        transparent: true,
        version: '1.3.0',
        cql_filter: '',
        srs: 'EPSG:4326',
        zIndex: 5,
      },
    },
    {
      id: 8,
      displayName: SUBDIVISION,
      apiName: 'boundaries1',
      geoServer: SUBDIVISION_GEOSERVER, // boundaries1
      payloadScale: 'om4a',
      option: {
        layers: 'openmod:boundaries1',
        format: 'image/png8',
        transparent: true,
        version: '1.3.0',
        cql_filter: '',
        srs: 'EPSG:4326',
        zIndex: 5,
      },
    },
    { id: 5, displayName: HECTARE, apiName: 'ha', geoServer: '', payloadScale: 'hectare' },
  ],
  cmsId: [
    'base_calculation_module_om4a',
    'evpv',
    'evpv_helper',
    'gtfs4ev',
    'atlite',
    'onsset',
    'infrafair',
    'opentepes',
    'plan4res',
  ], // Use this to work on base_cm in om4a. Can become default once base cm is added to dev
  // cmsId: [], // The order in this table defines the display order.
  scenarioExplorer: 'openmod4africa_internal',
}
